import { useTranslation } from "react-i18next";
import { ArrowLeftIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";

import { useActiveStep } from "~/hooks/useActiveStep";
import { useStepTitle } from "~/hooks/useStepTitle";
import { GoBackButton } from "~/modules/go-back-api";

export function ContentTitle({ isMobile }: { isMobile?: boolean }) {
  const { t } = useTranslation();
  const { activeStep, prevStep } = useActiveStep();
  const title = useStepTitle(activeStep);

  if (!title || !activeStep) {
    return null;
  }

  return (
    <div
      className={clsx(
        "relative grid gap-sm",
        "justify-items-center md:justify-items-start",
        "font-bold leading-6",
        isMobile && prevStep && "pl-md",
        !isMobile && "after:h-[4px] after:w-[64px] after:bg-brand-secondary after:content-['']",
      )}
      data-component="ContentTitle"
    >
      {isMobile && prevStep && (
        <GoBackButton
          aria-label={t("util.back")}
          className="p-xs"
          data-component="ContentTitleBack"
          formClassName="absolute -left-xs -top-2xs"
          stepId={prevStep.id}
        >
          <ArrowLeftIcon className="h-base w-base fill-secondary stroke-secondary" />
        </GoBackButton>
      )}
      <h1 className="text-lg md:text-base">{title}</h1>
    </div>
  );
}
